import { createSelector } from 'reselect'

import type { ReduxState } from '@/utils/typeHelpers'

export const selectSeparationQuestions = (state: ReduxState) =>
  state.separation.questions
export const selectSeparationStatus = (state: ReduxState) =>
  state.separation.status
export const selectSeparationCounts = (state: ReduxState) =>
  state.separation.counts
export const selectSeparationDeferred = (state: ReduxState) =>
  state.separation.deferred
export const selectSeparationSortedCount = (state: ReduxState) =>
  state.separation.sortedCount
export const selectSeparationReleased = (state: ReduxState) =>
  state.separation.released
export const selectSeparationLoadFailed = (state: ReduxState) =>
  state.separation.loadFailed

export const selectSeparationBusinessCount = (state: ReduxState) =>
  state.separation.counts.business
export const selectSeparationPersonalCount = (state: ReduxState) =>
  state.separation.counts.personal

/** Transactions behind the groups we never asked about. */
export const selectSeparationDeferredCount = createSelector(
  selectSeparationDeferred,
  (deferred) => deferred.reduce((sum, group) => sum + group.transactionCount, 0)
)

/**
 * Every group the bookkeeping team picks up, for the summary.
 *
 * `deferred` alone is the wrong list there. It means "outside this page's cap", so once the
 * flow stops asking, the page the server would have served next is neither answered nor
 * deferred, and the member is told a smaller number than the truth. Nothing in the latest
 * payload gets asked once the summary is on screen, so both halves belong here.
 */
export const selectSeparationUnasked = createSelector(
  selectSeparationQuestions,
  selectSeparationDeferred,
  (questions, deferred) => [
    ...(questions ?? []).map((question) => ({
      displayName: question.headerName,
      transactionCount: question.subItems.length,
      amount: question.amount,
      suggested: question.suggested || null,
    })),
    ...deferred,
  ]
)
